import React from 'react'
import classNames from 'classnames'

import styles from '../component-styles/intro.module.scss'
import SiteSelector from './site-selector'
import { BetaLabel } from './counter'

interface Props {
  children?: React.ReactNode | string
  title?: string | React.ReactElement
  className?: string
  isBeta?: boolean
}
export default function Intro({
  title,
  children,
  className,
  isBeta = false,
}: Props): React.ReactElement {
  return (
    <div className={classNames(styles.wrapper, className)}>
      <div className={styles.headerWrapper}>
        <h1 className={styles.header}>
          {title}
          {isBeta && <BetaLabel className={styles.beta} />}
        </h1>
        <div className={styles.selectorWrapper}>
          <SiteSelector className={styles.siteSelector} />
        </div>
      </div>
      {children}
    </div>
  )
}
